"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPublicAvailabilityInfo = fetchPublicAvailabilityInfo;
exports.fetchPublicAvailabilityInfoForOwner = fetchPublicAvailabilityInfoForOwner;
exports.fetchCompanyName = fetchCompanyName;
exports.getAvailability = getAvailability;
exports.createMeeting = createMeeting;
exports.bookMeeting = exports.createMeetingFailed = exports.createMeetingSucceeded = exports.createMeetingAction = exports.fetchCompanyNameFailed = exports.fetchCompanyNameSucceeded = exports.fetchCompanyNameAction = exports.fetchMeetingsUserFailed = exports.fetchMeetingsUserSucceeded = exports.fetchMeetingsUserStarted = exports.fetchPublicAvailabilityInfoForOwnerFailed = exports.fetchPublicAvailabilityInfoForOwnerSucceeded = exports.fetchPublicAvailabilityInfoForOwnerAction = exports.fetchPublicAvailabilityInfoFailed = exports.fetchPublicAvailabilityInfoSucceeded = exports.fetchPublicAvailabilityInfoSucceededAction = exports.fetchPublicAvailabilityInfoAction = exports.logMeetingCreation = void 0;

var _react = _interopRequireDefault(require("react"));

var _fluxActions = require("flux-actions");

var _actions = require("MeetingsBase/utils/actions");

var _getIn = _interopRequireDefault(require("transmute/getIn"));

var ActionTypes = _interopRequireWildcard(require("MeetingsLib/redux/actions/ActionTypes"));

var _immutable = require("immutable");

var _UIActions = require("./UIActions");

var _bookingAPI = require("MeetingsLib/api/bookingAPI");

var _userInfo = _interopRequireDefault(require("hub-http/userInfo"));

var _utils = require("MeetingsLib/utils/utils");

var _FormActions = require("./FormActions");

var _BookInfoSelectors = require("MeetingsLib/selectors/BookInfoSelectors");

var _FormFieldValidationSelector = require("MeetingsLib/selectors/FormFieldValidationSelector");

var _AutoSubmitSelector = require("MeetingsLib/selectors/AutoSubmitSelector");

var _RESTParamSelectors = require("MeetingsLib/selectors/RESTParamSelectors");

var _RequestStatusSelectors = require("MeetingsLib/selectors/RequestStatusSelectors");

var _PrefillSelectors = require("MeetingsLib/selectors/PrefillSelectors");

var _TroubleshootingSelectors = require("MeetingsLib/selectors/TroubleshootingSelectors");

var _PublicMeetingsUser = _interopRequireDefault(require("MeetingsBase/models/PublicMeetingsUser"));

var _PublicAvailabilityInfo = _interopRequireDefault(require("MeetingsBase/models/PublicAvailabilityInfo"));

var _FormState = _interopRequireDefault(require("MeetingsLib/models/FormState"));

var _TimeRange = _interopRequireDefault(require("MeetingsBase/models/TimeRange"));

var _UserProfile = _interopRequireDefault(require("MeetingsBase/models/UserProfile"));

var _Branding = _interopRequireDefault(require("MeetingsBase/models/Branding"));

var _errors = require("MeetingsLib/constants/errors");

var _enums = require("MeetingsBase/constants/enums");

var _status = require("MeetingsLib/constants/status");

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _LinkAvailability = _interopRequireDefault(require("MeetingsBase/models/LinkAvailability"));

var logMeetingCreation = (0, _fluxActions.createAction)(ActionTypes.LOG_MEETING_CREATE);
exports.logMeetingCreation = logMeetingCreation;
var fetchPublicAvailabilityInfoAction = (0, _actions.createRequestAction)(ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_STARTED);
exports.fetchPublicAvailabilityInfoAction = fetchPublicAvailabilityInfoAction;
var fetchPublicAvailabilityInfoSucceededAction = (0, _actions.createRequestAction)(ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED, function (res) {
  var bookInfo = _PublicAvailabilityInfo.default.from(res);

  var postResponse = {
    customFormFields: _FormState.default.customFieldsFromBookInfo(res),
    bookInfo: bookInfo,
    meetingsUser: _PublicMeetingsUser.default.fromBookInfo(bookInfo),
    branding: _Branding.default.from(res.brandingMetadata)
  };

  if (window.newrelic) {
    var hasMeetingsUser = !!postResponse.meetingsUser;
    window.newrelic.setCustomAttribute('bookInfoHasMeetingsUser', hasMeetingsUser);

    if (hasMeetingsUser) {
      window.newrelic.setCustomAttribute('calendarProvider', postResponse.meetingsUser.calendarProvider);
    }
  }

  return postResponse;
});
exports.fetchPublicAvailabilityInfoSucceededAction = fetchPublicAvailabilityInfoSucceededAction;

var fetchPublicAvailabilityInfoSucceeded = function fetchPublicAvailabilityInfoSucceeded(response, changeLocale) {
  return function (dispatch, getState) {
    var dispatchSuccess = function dispatchSuccess() {
      var state = getState();
      var disablePrefill = (0, _PrefillSelectors.getDisablePrefill)(state);

      if (disablePrefill) {
        response.formPrefills = {};
      }

      dispatch(fetchPublicAvailabilityInfoSucceededAction(response)); // get new state after dispatch above; see https://git.hubteam.com/HubSpot/MeetingsUI/pull/2367 for context

      state = getState();
      var initialFormState = (0, _FormFieldValidationSelector.getInitialFormState)(state);
      var shouldSetFormState = (0, _AutoSubmitSelector.canSubmitInitialPropertyForm)(state);

      if (initialFormState && shouldSetFormState) {
        dispatch((0, _FormActions.setFormState)(initialFormState));
      }
    };

    var locale = response.customParams.locale;
    var language = response.customParams.language;

    if (locale) {
      if (changeLocale) {
        changeLocale(locale, language).then(dispatchSuccess);
      } else {
        // legacy I18n locale change API - to be replaced by I18n Providers
        _I18n.default.langEnabled = language !== 'en';

        _I18n.default.changeLocale(locale).then(dispatchSuccess);
      }
    } else {
      dispatchSuccess();
    }
  };
};

exports.fetchPublicAvailabilityInfoSucceeded = fetchPublicAvailabilityInfoSucceeded;
var fetchPublicAvailabilityInfoFailed = (0, _actions.createRequestAction)(ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_FAILED, function (error) {
  return {
    error: error
  };
});
exports.fetchPublicAvailabilityInfoFailed = fetchPublicAvailabilityInfoFailed;
var fetchPublicAvailabilityInfoForOwnerAction = (0, _actions.createRequestAction)(ActionTypes.PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_STARTED);
exports.fetchPublicAvailabilityInfoForOwnerAction = fetchPublicAvailabilityInfoForOwnerAction;
var fetchPublicAvailabilityInfoForOwnerSucceeded = (0, _actions.createRequestAction)(ActionTypes.PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_SUCCEEDED, function (response) {
  var postResponse = {
    customFormFields: _FormState.default.customFieldsFromBookInfo(response),
    bookInfo: _PublicAvailabilityInfo.default.from(response)
  };
  return postResponse;
});
exports.fetchPublicAvailabilityInfoForOwnerSucceeded = fetchPublicAvailabilityInfoForOwnerSucceeded;
var fetchPublicAvailabilityInfoForOwnerFailed = (0, _actions.createRequestAction)(ActionTypes.PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_FAILED, function (error) {
  return {
    error: error
  };
});
exports.fetchPublicAvailabilityInfoForOwnerFailed = fetchPublicAvailabilityInfoForOwnerFailed;

var fetchWithEarlyRequestHook = function fetchWithEarlyRequestHook(fallbackFetch, requestName) {
  if (window.quickFetch) {
    var earlyRequest = window.quickFetch.getRequestStateByName(requestName);

    if (earlyRequest) {
      return new Promise(function (resolve, reject) {
        earlyRequest.whenFinished(function () {
          var mark = requestName + "-finished";

          if (window.performance && window.performance.mark && window.performance.measure) {
            window.performance.mark(mark);
            window.performance.measure(requestName + "-after-mount", 'create-booking-component', mark);
          }

          resolve.apply(void 0, arguments);
        });
        earlyRequest.onError(function () {
          return reject.apply(void 0, arguments);
        });
      });
    }
  }

  return fallbackFetch();
};

var fetchMeetingsUserStarted = (0, _actions.createRequestAction)(ActionTypes.MEETINGS_USER_FETCH_STARTED);
exports.fetchMeetingsUserStarted = fetchMeetingsUserStarted;
var fetchMeetingsUserSucceeded = (0, _actions.createRequestAction)(ActionTypes.MEETINGS_USER_FETCH_SUCCEEDED, function (response) {
  var meetingsUser = _PublicMeetingsUser.default.from(response);

  if (window.newrelic) {
    window.newrelic.setCustomAttribute('calendarProvider', meetingsUser.calendarProvider);
  }

  return {
    meetingsUser: meetingsUser
  };
});
exports.fetchMeetingsUserSucceeded = fetchMeetingsUserSucceeded;
var fetchMeetingsUserFailed = (0, _actions.createRequestAction)(ActionTypes.MEETINGS_USER_FETCH_FAILED, function (error) {
  return {
    error: error
  };
});
exports.fetchMeetingsUserFailed = fetchMeetingsUserFailed;

function fetchMeetingsUser() {
  return function (dispatch, getState, httpClient) {
    var slug = getState().userSlug;
    dispatch(fetchMeetingsUserStarted());
    return (0, _bookingAPI.fetchMeetingsUser)(httpClient, slug, true).then(function (response) {
      dispatch(fetchMeetingsUserSucceeded(response));
    }, function (response) {
      dispatch(fetchMeetingsUserFailed(response));
    });
  };
}

function fetchPortalAuth(portalId) {
  return function (dispatch, getState) {
    var shouldAllowTroubleshoot = (0, _TroubleshootingSelectors.shouldAllowTroubleshootMode)(getState());

    if (shouldAllowTroubleshoot) {
      (0, _userInfo.default)({
        portalId: portalId,
        ignoreRedirect: true
      }).then(function (res) {
        dispatch({
          type: ActionTypes.PORTAL_AUTH_SUCCEEDED,
          payload: res
        });
      }, function () {});
    }
  };
}

var createPublicAvailabilityFetcher = function createPublicAvailabilityFetcher(dispatch, getState, httpClient, params) {
  var state = getState();
  var queryParams = (0, _RESTParamSelectors.getFetchAvailabilityQueryParams)(params)(state);
  return function () {
    return (0, _bookingAPI.fetchPublicAvailabilityInfo)(httpClient, queryParams);
  };
};

function fetchPublicAvailabilityInfo(params, changeLocale) {
  return function (dispatch, getState, httpClient) {
    dispatch(fetchPublicAvailabilityInfoAction());
    var fetch = createPublicAvailabilityFetcher(dispatch, getState, httpClient, params);
    var fetchPromise = fetchWithEarlyRequestHook(fetch, 'book-info');
    return fetchPromise.then(function (response) {
      var bookInfo = _PublicAvailabilityInfo.default.from(response);

      var meetingsUser = _PublicMeetingsUser.default.fromBookInfo(bookInfo);

      var portalId = bookInfo.portalId;
      dispatch(fetchPortalAuth(portalId));

      if (!meetingsUser) {
        return fetchMeetingsUser()(dispatch, getState, httpClient).then(function () {
          dispatch(fetchPublicAvailabilityInfoSucceeded(response, changeLocale));
          return bookInfo;
        });
      } else {
        dispatch(fetchPublicAvailabilityInfoSucceeded(response, changeLocale));
        return bookInfo;
      }
    }, function (error) {
      dispatch(fetchPublicAvailabilityInfoFailed(error)); // redirect users who try to hit meeting links on
      // www.hubspot.com when they are not hosted there

      if (error && error.status === _status.STATUS.NOT_FOUND) {
        (0, _utils.maybeRedirectToHubSpotDomain)(window.location.host);
      }

      throw error;
    });
  };
}

function fetchPublicAvailabilityInfoForOwner(params) {
  return function (dispatch, getState, httpClient) {
    dispatch(fetchPublicAvailabilityInfoForOwnerAction());
    var fetch = createPublicAvailabilityFetcher(dispatch, getState, httpClient, params);
    return fetch().then(function (response) {
      dispatch(fetchPublicAvailabilityInfoForOwnerSucceeded(response));
      return _PublicAvailabilityInfo.default.from(response);
    }, function (error) {
      dispatch(fetchPublicAvailabilityInfoForOwnerFailed(error));
      return Promise.reject(error);
    });
  };
}

var fetchCompanyNameAction = (0, _actions.createRequestAction)(ActionTypes.COMPANY_NAME_FETCH_STARTED);
exports.fetchCompanyNameAction = fetchCompanyNameAction;
var fetchCompanyNameSucceeded = (0, _actions.createRequestAction)(ActionTypes.COMPANY_NAME_FETCH_SUCCEEDED, function (response) {
  return response.companyName;
});
exports.fetchCompanyNameSucceeded = fetchCompanyNameSucceeded;
var fetchCompanyNameFailed = (0, _actions.createRequestAction)(ActionTypes.COMPANY_NAME_FETCH_FAILED, function (error) {
  return {
    error: error
  };
});
exports.fetchCompanyNameFailed = fetchCompanyNameFailed;

function fetchCompanyName() {
  return function (dispatch, getState, httpClient) {
    dispatch(fetchCompanyNameAction());
    var slug = encodeURIComponent(getState().userSlug);
    return (0, _bookingAPI.fetchCompanyName)(httpClient, slug).then(function (response) {
      dispatch(fetchCompanyNameSucceeded(response));
      return response;
    }, function (error) {
      dispatch(fetchCompanyNameFailed(error));
    });
  };
}

function getAvailability(changeLocale) {
  return function (dispatch, getState) {
    if ((0, _BookInfoSelectors.shouldFetchAvailability)(getState())) {
      var params = {
        includeDeleted: 'true'
      };
      dispatch(fetchPublicAvailabilityInfo(params, changeLocale)).then(function (bookInfo) {
        if (bookInfo && bookInfo.linkType === _enums.LINK_TYPES.get(_enums.MEETING_TYPES.ROUND_ROBIN) && !(0, _getIn.default)(['customParams', 'displayInfo', 'headline'], bookInfo)) {
          dispatch(fetchCompanyName());
        }
      }, function (error) {
        if (error && error.status === 404) {
          return dispatch(fetchMeetingsUser());
        }

        throw error;
      });
    }

    return Promise.resolve();
  };
}

var createMeetingAction = (0, _actions.createRequestAction)(ActionTypes.MEETING_CREATE_STARTED);
exports.createMeetingAction = createMeetingAction;
var createMeetingSucceeded = (0, _actions.createRequestAction)(ActionTypes.MEETING_CREATE_SUCCEEDED, function (response) {
  var postResponse = new _immutable.Map({
    timerange: _TimeRange.default.from({
      start: response.start,
      end: response.end
    }),
    organizer: _UserProfile.default.from(response.organizer)
  });
  return postResponse;
});
exports.createMeetingSucceeded = createMeetingSucceeded;
var createMeetingFailed = (0, _actions.createRequestAction)(ActionTypes.MEETING_CREATE_FAILED, function (error) {
  return {
    error: error
  };
});
exports.createMeetingFailed = createMeetingFailed;
var bookingTimeConflict = (0, _fluxActions.createAction)(ActionTypes.BOOKING_TIME_CONFLICT, function (linkAvailability) {
  return {
    linkAvailability: _LinkAvailability.default.from(linkAvailability)
  };
}, function () {
  return (0, _actions.createRequestStatusMeta)(ActionTypes.MEETING_CREATE_UNINITIALIZED);
});

function createMeeting(event) {
  return function (dispatch, getState, httpClient) {
    dispatch(createMeetingAction());
    var state = getState();
    var data = (0, _RESTParamSelectors.getCreateMeetingBodyData)(event)(state);
    var queryParams = (0, _RESTParamSelectors.getCreateMeetingQueryParams)(state);
    return (0, _bookingAPI.createMeeting)(httpClient, queryParams, data).then(function (response) {
      dispatch(createMeetingSucceeded(response));
      return response;
    }, function (error) {
      if (error.status === 400 && error.responseJSON && error.responseJSON.errorType === 'TIME_SLOT_NOT_AVAILABLE') {
        dispatch(bookingTimeConflict(error.responseJSON.linkAvailability));
        throw Error(_errors.BOOKING_TIME_CONFLICT);
      }

      dispatch(createMeetingFailed(error));
      throw error;
    });
  };
}

var bookMeeting = function bookMeeting() {
  return function (dispatch, getState) {
    var state = getState();
    var isSalesStarter = state.isSalesStarter,
        calendarProvider = state.calendarProvider,
        linkType = state.bookInfo.linkType,
        event = state.bookingLifecycle.event;

    var _getUserProfileSelect = (0, _BookInfoSelectors.getUserProfile)(state),
        email = _getUserProfileSelect.email;

    var submittingMeeting = (0, _RequestStatusSelectors.isSubmittingMeeting)(state);

    if (submittingMeeting) {
      return;
    }

    dispatch(createMeeting(event)).then(function () {
      dispatch(logMeetingCreation({
        integration: calendarProvider,
        linkType: linkType,
        isSalesStarter: isSalesStarter
      }));
    }, function (error) {
      if (error.message === _errors.BOOKING_TIME_CONFLICT) {
        dispatch((0, _UIActions.showUserMessage)({
          type: 'info',
          content: _react.default.createElement(_FormattedHTMLMessage.default, {
            message: "errorMessages.bookedFromUnder"
          })
        }));
      } else {
        dispatch((0, _UIActions.showUserMessage)({
          type: 'danger',
          content: _react.default.createElement(_FormattedHTMLMessage.default, {
            message: "errorMessages.tryAgain",
            options: {
              email: email
            }
          })
        }));
      }
    });
  };
};

exports.bookMeeting = bookMeeting;